function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var resize = function resize(event, tabs) {
  var stickyTabs = tabs.props.stickyTabs;

  if (stickyTabs) {
    tabs.setState({
      windowHeight: window.innerHeight
    });
  }
};

var watchTabs = function watchTabs(event, tabs) {
  var _tabs$state = tabs.state,
      windowHeight = _tabs$state.windowHeight,
      stickToBottom = _tabs$state.stickToBottom;

  if (tabs.stickyWrapper && tabs.contentWrapperRef) {
    var tabsDiff = tabs.stickyWrapper.offsetHeight - windowHeight;
    var contentScrollY = tabs.contentWrapperRef.getBoundingClientRect().y;

    if (contentScrollY >= -tabsDiff && stickToBottom) {
      tabs.setState({
        stickToBottom: false,
        stickToTop: true
      });
    }
  }
};

var observeEntrance = function observeEntrance(container, tabsDiff, tabs) {
  var stickyTabs = tabs.props.stickyTabs;
  var _tabs$state2 = tabs.state,
      windowHeight = _tabs$state2.windowHeight,
      stickToBottom = _tabs$state2.stickToBottom,
      stickToTop = _tabs$state2.stickToTop;
  var threshold = windowHeight / container.offsetHeight;
  var tabObserver = new IntersectionObserver(function (records, observer) {
    var _iterator = _createForOfIteratorHelper(records),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var record = _step.value;

        if (record.isIntersecting && !tabs.previousIntersection) {
          tabs.previousIntersection = record.isIntersecting; //hit bottom edge of content

          if (Math.abs(record.boundingClientRect.top) > record.intersectionRect.height) {
            if (!stickToBottom && !stickToTop) {
              if (tabs.stickyWrapper.offsetHeight - window.innerHeight < 0) return;
              tabs.setState({
                stickToBottom: true
              });
            }
          }
        } else if (!record.isIntersecting && tabs.previousIntersection) {
          tabs.setState({
            stickToTop: false,
            stickToBottom: false
          });
          tabs.previousIntersection = false;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }, {
    threshold: threshold
  });
  tabs.tabObserver = tabObserver;
  return tabObserver.observe(container);
};

export { resize, watchTabs, observeEntrance };